import React from 'react';
const autobind = require('class-autobind').default;
import { FormGroup } from '../group/index';
import { Input } from '../input/index';
import { Button } from '../../button/index';
import InputMask from 'react-input-mask';
import DayPicker from 'react-day-picker';
import moment from 'moment-timezone';
import { FORMATS } from '@lib/common';
export class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            date: new Date(),
            time: '',
            time_error: '',
        };
    }
    onSelect() {
        const { timezone, onSelect, disableTimePicker } = this.props;
        const { date, time } = this.state;
        if (!time && !disableTimePicker) {
            this.setState({ time_error: 'Required' });
            return;
        }
        else if (!time && disableTimePicker) {
            this.setState({ time: '00:00' });
        }
        else if (time.length !== 5) {
            this.setState({ time_error: 'Invalid, e.g. 15:00' });
            return;
        }
        // const iso_date = date.toISOString().split("T")[0];
        // const parsed = DateTime.fromFormat(`${iso_date} ${time}`, `yyyy-MM-dd hh:mm`, { zone: timezone }) . isValid;
        let parsed = moment.tz(date, timezone);
        parsed = moment.tz(`${parsed.format(FORMATS.moment.date)} ${time}`, FORMATS.moment.datetime, timezone);
        if (parsed.isValid()) {
            onSelect(parsed.valueOf());
        }
        else {
            this.setState({ time_error: 'Invalid, e.g. 15:00' });
        }
    }
    render() {
        const { disableTimePicker } = this.props;
        const { date, time, time_error } = this.state;
        return (React.createElement("div", null,
            React.createElement(FormGroup, { contentClassName: "flex-center", className: "p-b-0" },
                React.createElement(DayPicker, { selectedDays: date, onDayClick: d => this.setState({ date: d }) })),
            !disableTimePicker && (React.createElement(FormGroup, { title: "Time (24H)", small_title: true, error: time_error },
                React.createElement(InputMask, { mask: "99:99", value: time, onChange: e => this.setState({ time: e.target.value }) }, (inputProps) => (React.createElement(Input, { type: "text", className: "no-round", placeholder: "00:00", ...inputProps }))))),
            React.createElement(FormGroup, null,
                React.createElement(Button, { color: "primary-inverse", size: "xs", full: true, type: "button", onClick: this.onSelect }, "Select"))));
    }
}
//# sourceMappingURL=index.js.map